import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {useAppContext} from '../PlanYourVisitApp';


export default function ThanksRoute({location}) {
  const {ICS_Link} = (location.state || {});
  const appContext = useAppContext();

  useEffect(() => {
    console.log('useEffect', ICS_Link, appContext);
    if (appContext.onSuccessCallback) {
      appContext.onSuccessCallback({ICS_Link});
    }
  }, [ICS_Link]);

  return <div className='thanks-route' />;
}


// WEBPACK FOOTER //
// ./src/components/thanks-route/index.js